import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { VerifyHealthGuidelineCategorizationResponse } from '../../responses/orchestrator-classification/verify-health-guideline-categorization.response';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class CareLinePriorityHealthGuidelineService extends CommonService {

  constructor(private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public verifyCategorization(idCareLinePriority: number): Observable<VerifyHealthGuidelineCategorizationResponse> {
    return this.httpClient.get<VerifyHealthGuidelineCategorizationResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorClassification) + `CareLinePriorityHealthGuideline/idCareLinePriority/${idCareLinePriority}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteCareLinePriority(idCareLinePriority: number, listIdHealthGuidelineCategorization: number[]): Observable<ReturnStruct> {
    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorClassification) + `CareLinePriorityHealthGuideline/idCareLinePriority/${idCareLinePriority}`, listIdHealthGuidelineCategorization, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}